import { IConference } from "@/models/Conference.model";
const state = {
  conferences: [],
  conference: { _id: null, title: "", link: "" },
};
const getters = {
  // @ts-ignore
  getConferenceTitle: (state) => state.conference.title,
  // @ts-ignore
  getConferenceId: (state) => state.conference._id,
  // @ts-ignore
  getConference: (state) => state.conference,
  // @ts-ignore
  getAllConferences: (state) => state.conferences,
};

const mutations = {
  // @ts-ignore
  setConference(state, conference: IConference) {
    state.conference = conference;
  },
  // @ts-ignore
  setConferences(state, conferences: IConference[]) {
    state.conferences = conferences;
  },
};

const actions = {};

export default { state, getters, mutations, actions };
